var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 237,
    viewBox: "0 0 229 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 1",
    filter: "url(#filter0_d_13_30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 44,
    y: 149,
    width: 56,
    height: 95,
    transform: "rotate(-90 44 149)",
    fill: "#012559"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    x: 75,
    y: 123,
    width: 56,
    height: 95,
    fill: "#012559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M13 121L59.5 62.1103L59.5 179.89L13 121Z",
    fill: "#012559"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 84,
    y: 49,
    width: 56,
    height: 169,
    fill: "#076CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M112 3L170.89 49.5H53.1103L112 3Z",
    fill: "#076CFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3",
    filter: "url(#filter1_i_13_30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 114,
    y: 106,
    width: 44,
    height: 112,
    fill: "#75ADFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 114,
    y: 162,
    width: 56,
    height: 66,
    transform: "rotate(-90 114 162)",
    fill: "#75ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M220 134L173.5 192.89L173.5 75.1103L220 134Z",
    fill: "#75ADFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_30",
    x: 0.2,
    y: 0.2,
    width: 228.6,
    height: 236.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_30",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_13_30",
    x: 114,
    y: 75.1102,
    width: 106,
    height: 146.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13_30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon 1.4500df1574cb2ac0524e611cd28afb34.svg";
export { ForwardRef as ReactComponent };